import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Container, Button } from 'react-bootstrap';

function PrayerDisplayPage() {
  const { category, lang } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [prayer, setPrayer] = useState('');
  const [showButton, setShowButton] = useState(false);

  const homeText = {
    en: 'Home',
    es: 'Regresar',
    ru: 'Вернуться', // This is the Russian word for Home
  };

  useEffect(() => {
    const validLangs = ['en', 'es', 'ru', 'tl'];

    if (!validLangs.includes(lang)) {
      navigate('/en');
      return;
    }

    const fetchPrayer = async () => {
      try {
        const res = await fetch(`/${lang}/${category}.json`);
        const data = await res.json();
        const random = data[Math.floor(Math.random() * data.length)];
        setPrayer(random.prayer);
      } catch (err) {
        setPrayer('Could not load prayer.');
      }
    };

    fetchPrayer();

    const timer = setTimeout(() => setShowButton(true), 3000);
    return () => clearTimeout(timer);
  }, [lang, category, navigate]);

  const returnTo = location.state?.from || `/${lang}`;

  return (
    <Container className="mt-5 text-center">
      <h2 className="fade-in" style={{ whiteSpace: 'pre-line' }}>{prayer}</h2>
      <div style={{ height: '3rem', marginTop: '1.5rem' }}>
        {showButton && (
          <Button
            className="glass-button bg-transparent border-0 fade-in-button"
            onClick={() => navigate(returnTo)}
          >
            {homeText[lang] || 'Home'}
          </Button>
        )}
      </div>
    </Container>
  );
}

export default PrayerDisplayPage;

